import { localThemes, theme as Theme } from "../theme";
import { makeStyles } from "@mui/styles";
const mainTheme = Theme;
const palette: { [key: string]: any } = mainTheme.palette;
const skin = localThemes?.includes(window?.location?.search?.split("skin=")[1])
  ? window?.location?.search?.split("skin=")[1]
  : "primary";

export const styles = {
  consentCard: {
    padding: "2px 10px",
    borderRadius: 10,
    marginBottom: 10,
    marginTop: 10,
    backgroundColor: palette[skin]?.bacckground,
    height: "190px",
    overflow: "auto",
  },
  shield: {
    width: "217px",
    zIndex: 9999999,
    opacity: 0.85,
  },
  overlay: {
    zIndex: "9999999",
    position: "absolute",
    left: 0,
    top: "45px",
    width: "101%",
    height: "88%",
    backgroundColor: "rgba(251, 251, 251, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  overlayCamera: {
    zIndex: "9999999",
    position: "absolute",
    left: 0,
    top: "56px",
    width: "100%",
    height: "82%",
    backgroundColor: "rgba(251, 251, 251, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  input: {
    width: "100%",
    outline: "none",
    borderRadius: 5,
    color: palette[skin]?.listText,
    height: 50,
    padding: "10px 10px",
    boxSizing: "border-box",
    border: `1px solid ${palette[skin]?.listText}`,
    margin: "10px 0px",
    fontSize: 15,
  },
  ageVerifiedButton: {
    fontSize: 20,
    backgroundColor: palette[skin]?.cvs,
    justifyContent: "space-between",
    padding: "16px",
    boxShadow: `0px 2px 8px rgba(0, 0, 0, 0.25)`,
    margin: "0 20px 5px 0",
    minWidth: 350,
    // border: `2px solid ${palette[skin]?.cvs}`,
    color: "#fff",
  },
  ageFailedButton: {
    fontSize: 20,
    backgroundColor: palette[skin]?.error,
    boxShadow: `0px 0px 20px -7px ${palette[skin]?.error}`,
    margin: "0 20px 5px 0",
    minWidth: 300,
    border: `3px solid ${palette[skin]?.error}`,
    color: palette[skin]?.text,
  },
  ageLearnMoreButton: {
    color: palette[skin]?.listText,
    fontSize: 20,
    display: "block",
  },
  continueButton: {
    fontSize: 20,
    backgroundColor: palette[skin]?.cvs,
    // boxShadow: `0px 0px 20px -7px ${palette[skin]?.main}`,
    margin: "10px auto",
    minWidth: 300,
    border: `2px solid ${palette[skin]?.cvs}`,
    display: "block",
    borderRadius: 7,
    height: 40,
    "::hover": {
      backgroundColor: "transparent",
    },
  },

  continueButtonInverted: {
    fontSize: 20,
    backgroundColor: palette[skin]?.cvsInverted,
    // boxShadow: `0px 0px 20px -7px ${palette[skin]?.main}`,
    margin: "10px auto",
    minWidth: 300,
    border: `2px solid ${palette[skin]?.cvsInverted}`,
    display: "block",
    borderRadius: 7,
    height: 40,
    "::hover": {
      backgroundColor: `${palette[skin]?.textBlack}`,
      color: `${palette[skin]?.text}`,
      border: `2px solid ${palette[skin]?.cvsInverted}`
    },
  },

  cardGrid: {
    minHeight: 250,
    padding: "0px 20px",
  },
  requestAddressCardGrid: {
    minHeight: "390px !important",
    padding: "0px 20px",
  },
  scanLoader: {
    width: 30,
    height: 30,
    marginBottom: "-9px",
    marginRight: "10px",
  },
  DlFront: {
    position: "absolute",
    zIndex: 999999,
    left: "-69px",
    width: "250px",
    top: "41px",
  },
  AnimationImage: {
    margin: "0 auto",
    display: "block",
    marginBottom: "-2px",
  },
};

export const useStyles = makeStyles((theme: any) => ({
  headerBoxLogo: {
    padding: 0,
    marginRight: 10,
  },
  dlImage: {
    // maxWidth: "300px",
    margin: "0 auto",
    display: "block",
    marginTop: "50px",
    [theme.breakpoints.between("xs", "sm")]: {
      width: "350px",
      marginTop: 60,
    },
    [theme.breakpoints.down(360)]: {
      width: "100%",
      marginTop: "20px",
    },
    [theme.breakpoints.between(1024, 1200)]: {
      marginTop: 60,
    },
  },
  healthCard: {
    maxWidth: "350px",
    margin: "0 auto",
    display: "block",
    marginTop: "15px",
    [theme.breakpoints.down(360)]: {
      width: "100%",
      marginTop: "20px",
    },
  },
  passport: {
    maxHeight: "200px",
    margin: "0 auto",
    display: "block",
    marginTop: "15px",
    [theme.breakpoints.down(360)]: {
      width: "100%",
      marginTop: "20px",
    },
  },
  cardHeaderWrap: {
    backgroundColor: palette[skin]?.backgroundRed,
  },
  cardHeading: {
    display: "flex",
    alignItems: "center",
    color: palette[skin]?.text,
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "14px !important",
      paddingTop: "10px !important",
      paddingBottom: "10px !important",
    },
  },
  cardInnerHeading: {
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "20px !important",
    },
    [theme.breakpoints.down(380)]: {
      marginTop: "10px !important",
      paddingLeft: 15,
      paddingRight: 15,
    },
  },
  cardInnerText: {
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "16px !important",
    },
  },
  cardGridMobile: {
    height: "350px",
    overflow: "auto",
    minHeight: "unset !important",
    [theme.breakpoints.between("xs", "sm")]: {
      height: "calc(100% - 170px)",
      overflow: "auto",
      minHeight: "unset",
      padding: " 0 10px !important",
    },
    [theme.breakpoints.down(380)]: {
      height: "calc(100% - 140px)",
    },
    "@media (orientation: landscape)": {
      [theme.breakpoints.down(1024)]: {
        // height: "calc(100% - 112px)",
      },
    },
    "& .DlBack": {
      [theme.breakpoints.between("xs", "sm")]: {
        left: "-10px !important",
        width: "170px !important",
        top: "43px !important",
      },
    },
  },
  AnimationImage: {
    [theme.breakpoints.down(380)]: {
      width: "100%",
      marginTop: "20px !important",
    },
    "@media (orientation: landscape)": {
      [theme.breakpoints.down(1024)]: {
        width: "100%",
      },
    },
  },
  consentCard: {
    padding: "10px",
    borderRadius: 10,
    marginBottom: 10,
    marginTop: 10,
    backgroundColor: palette[skin]?.bacckground,
    height: "250px",
    overflow: "auto !important",
    boxShadow: `0px 0px 28px -16px ${palette[skin]?.listText}  !important`,
    [theme.breakpoints.between("xs", "sm")]: {
      height: "calc(100% - 100px)",
    },
  },
  homeLoader: {
    color: `${palette[skin]?.text} !important`,
    height: "35px !important",
    width: "35px !important",
    marginTop: "-6px !important",
  },
  otherOptions: {
    position: "absolute",
    top: -35,
    "& p": {
      cursor: "pointer",
      color: palette[skin]?.main,
      marginLeft: -4,
    },
    "& p:hover": {
      textDecoration: "underline",
    },
    "& svg": {
      position: "relative",
      top: 6.5,
      color: palette[skin]?.main,
      width: "21px",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      top: -38,
    },
  },
  listText: {
    display: "list-item !important",
    padding: "0 16px !important",
    fontSize: "12px !important",
    color: palette[skin]?.listText,
    lineHeight: "22px",
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "12px !important",
      padding: "10px 16px !important",
    },
  },
  inputStyle: {
    marginBottom: "10px !important",
    marginTop: "10px !important",
  },
  scanLoader: {
    width: "22px !important",
    height: "22px !important",
    marginBottom: "2px",
    marginRight: "0px",
    color: `${palette[skin]?.text} !important`,
    [theme.breakpoints.between("xs", "sm")]: {
      color: `${palette[skin]?.text} !important`,
    },
  },
  cardSxMobile: {
    [theme.breakpoints.between("xs", "sm")]: {
      padding: "0px 10px",
    },
  },
  crossErrorIcon: {
    color: palette[skin]?.error,
    fontSize: "180px !important",
    margin: "0 auto !important",
    display: "block !important",
    marginTop: "30px !important",
  },
  checkIcon: {
    color: palette[skin]?.main,
    fontSize: "61px !important",
    margin: "0 auto !important",
    display: "block !important",
    marginTop: "10px !important",
    [theme.breakpoints.down(380)]: {
      width: "100%",
    }
  },
  allowCameraBox: {
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 0px 14px -5px #000",
    borderRadius: "10px",
    marginTop: "10px",
    margin: "10px auto",
  },
  otherOptionsBottom: {
    position: "unset",
    display: "flex",
    justifyContent: "center",
    paddingBottom: 0,
    "& p": {
      cursor: "pointer",
      color: palette[skin]?.main,
      marginLeft: 0,
      marginTop: 0,
    },
    "& p:hover": {
      textDecoration: "underline",
    },
    "& svg": {
      position: "relative",
      top: 6.5,
      color: palette[skin]?.main,
      width: "21px",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      top: -38,
    },
  },
  alertWrap: {
    cursor: "pointer",
    "@media (orientation: landscape)": {
      [theme.breakpoints.down(1024)]: {
        display: "none !important"
      },
    },
  },
  scanBottomBox: {
    [theme.breakpoints.between("xs", "sm")]: {
      height: "33% !important",
      flexDirection: "column",
      display: "flex",
    },
    "& > div": {
      [theme.breakpoints.between("xs", "sm")]: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        paddingLeft: 0,
      },
    },
  },
  otherDevice: {
    position: "relative",
    "& p": {
      cursor: "pointer",
      color: palette[skin]?.main,
      marginLeft: -4,
    },
    "& p:hover": {
      textDecoration: "underline",
    },
    "& svg": {
      position: "relative",
      top: 6.5,
      color: palette[skin]?.main,
      width: "21px",
    },
  },
  feedbackIconsWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  feedBackIcon: {
    // width: "0px !important",
    flexDirection: "column",
    padding: "0px 10px !important",
    width: "unset !important",
    cursor: "pointer",
    "& svg": {
      fontSize: 50,
    },
    "& p": {
      // width: "100%",
      textAlign: "center",
      margin: "0px",
      fontSize: 12,
    },
  },
  feedBackIconImage: {
    width: 40,
    height: 40,
    marginBottom: 6,
    marginTop: 6,
  },
  textArea: {
    width: "100%",
    outline: "none",
    borderRadius: 5,
    color: palette[skin]?.listText,
    padding: "5px 5px",
    boxSizing: "border-box",
    border: `1px solid ${palette[skin]?.listText}`,
    fontSize: 15,
    fontFamily: "Lato,sans-serif",
  },
  firstGrid: {
    [theme.breakpoints.between("xs", "sm")]: {
      height: "calc(100% - 229px)",
      overflow: "auto",
      minHeight: "unset",
    },
  },
  skipToContentLink: {
    left: "50%",
    position: "absolute",
    transform: "translateY(-100%)",
  },
  setfieImage: {
    [theme.breakpoints.between("xs", "sm")]: {
      display: "block",
      margin: "0 auto",
    },
  },
  continueButton: {
    "&:disabled": {
      opacity: "0.6"
    },
    "&:hover": {
      backgroundColor: "transparent !important",
      "& p": {
        color: `${palette[skin]?.cvs} !important`,
      },
      "& svg": {
        color: `${palette[skin]?.cvs} !important`,
      },
    },
  },

  continueButtonInverted: {
    "&:disabled": {
      opacity: "0.6"
    },
    "&:hover": {
      backgroundColor: `${palette[skin]?.textBlack} !important`,
      borderColor: `${palette[skin]?.cvsInverted} !important`,
      "& p": {
        color: `${palette[skin]?.text} !important`,
      },
      "& svg": {
        color: `${palette[skin]?.text} !important`,
      },
    },
  },
  checkBoxCard: {
    padding: "5px 15px",
    marginBottom: 20,
    border: `2px solid #fff`,
    "& label": {
      width: "100%"
    },
    "& .Mui-checked": {
      color: `${palette[skin]?.cvs} !important`,
    },
  },
  activeBorder: {
    border: `2px solid ${palette[skin]?.cvs}`
  },
}));
